module.exports = __webpack_public_path__ + "static/assets/9b6365fc68820b626eedbbb0060f6ead.png";